import { render, staticRenderFns } from "./ShopifySavebar.vue?vue&type=template&id=b91f0498&scoped=true"
import script from "./ShopifySavebar.vue?vue&type=script&lang=js"
export * from "./ShopifySavebar.vue?vue&type=script&lang=js"
import style0 from "./ShopifySavebar.vue?vue&type=style&index=0&id=b91f0498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91f0498",
  null
  
)

export default component.exports